import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Imprimir", -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "ant-row" }
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_6 = {
  class: "ant-row",
  style: {"margin-top":"8px"}
}
const _hoisted_7 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_8 = { style: {"color":"#666","font-size":"13px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    style: {"z-index":"999"},
    width: 480,
    centered: "",
    maskClosable: false,
    title: "Imprimir Etiquetas de Produtos"
  }, {
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "ant-btn ant-btn-lg ant-btn-secondary",
        style: {"color":"white","background-color":"dodgerblue"},
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.imprimir()))
      }, _hoisted_2)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_form, { layout: "vertical" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_a_form_item, {
                label: "Tipo de Etiqueta",
                class: "ss-margin-campos"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    value: _ctx.state.tipoEtiqueta,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.tipoEtiqueta) = $event)),
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select_option, { value: "padrao" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Etiqueta Padrão")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: "semPreco" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Etiqueta Sem Preço")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_a_form_item, {
                label: "Qtd por Linha",
                class: "ss-margin-campos"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    value: _ctx.state.qtdPorLinha,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.qtdPorLinha) = $event)),
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select_option, { value: "2" }, {
                        default: _withCtx(() => [
                          _createTextVNode("2")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: "3" }, {
                        default: _withCtx(() => [
                          _createTextVNode("3")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.props.produtos.length) + " produto(s) selecionado(s) para impressão. ", 1)
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_requisicao_modal, {
        visivel: _ctx.modalBase.exibirRequisicaoModal,
        "onUpdate:visivel": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
        retornoRequisicao: _ctx.modalBase.retornoRequisicao,
        apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
        fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso
      }, null, 8, ["visivel", "retornoRequisicao", "apresentarBarraProgresso", "fraseBarraProgresso"])
    ]),
    _: 1
  }, 8, ["visible"]))
}